(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SoggettoEsternoController', SoggettoEsternoController);

    SoggettoEsternoController.$inject = ['SoggettoEsterno', 'Atto', '$stateParams', '$state'];

    function SoggettoEsternoController(SoggettoEsterno, Atto, $stateParams, $state) {

        var vm = this;
        vm.basicSearchLegislatura = $stateParams.legislatura;

        vm.soggettoEsternos = [];
        vm.transition = transition;

        vm.legislature = [];
        Atto.queryLegislature({}, onSuccessLeg, onErrorLeg);

        function onSuccessLeg(data){
            vm.legislature=data;
            if(vm.legislature && vm.legislature.indexOf(11) === -1) {
                vm.legislature.push(11);
            }
        }
        function onErrorLeg(error){
            console.log("Failure!", error);
            toastr.error(error.data.message);
        }

        loadAll();

        function loadAll() {
            SoggettoEsterno.query({legislature: vm.basicSearchLegislatura}, function(result) {
                vm.soggettoEsternos = result;
                vm.searchQuery = null;
            });
        }

        function transition() {

            if(vm.basicSearchLegislatura && vm.basicSearchLegislatura !== 'ALL') {
                $state.transitionTo($state.$current, {
                    legislatura: vm.basicSearchLegislatura
                });
            }else {
                console.log(vm.basicSearchLegislatura)
                $state.transitionTo($state.$current, {
                    legislatura: null
                });
            }
        }
    }
})();
